import script from "./match-marketing-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./match-marketing-modal.vue?vue&type=script&setup=true&lang=ts"

import "./match-marketing-modal.vue?vue&type=style&index=0&id=15c2141b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15c2141b"]])

export default __exports__